import type { ShareApp } from '@/lib/nativeCamera'

/**
 * The caption in three styles, one per app (Brian's record.html, after a take):
 *   Instagram   the caption as written.
 *   TikTok      the first two sentences and the first three hashtags.
 *   YouTube     the headline, the first paragraph, "Sourced: …", the tags.
 * The story's caption is the body, a blank line, then the hashtags.
 */
export function captionFor(app: ShareApp, story: { caption: string | null; headline: string; source_name: string | null; summary?: string | null }): string {
  const c = (story.caption || story.summary || story.headline || '').replace(/<[^>]+>/g, '').trim()
  const [body = '', tags = ''] = c.split('\n\n')
  if (app === 'tiktok') {
    const short = body.split('. ').slice(0, 2).join('. ').replace(/\.?$/, '.')
    const t = tags.split(' ').slice(0, 3).join(' ')
    return t ? `${short}\n\n${t}` : short
  }
  if (app === 'youtube') {
    return [story.headline, body, story.source_name ? `Sourced: ${story.source_name}.` : '', tags].filter(Boolean).join('\n\n')
  }
  return c
}
